import {LANDING} from '../../config/landingConfig';

// Логотип + подпись бренда. Тексты берутся из landingConfig (LANDING.brand),
// так же как и остальной текст лендинга. Используется в шапке и подвале.
// `overlay` — светлый вариант для шапки поверх фото героя.
export default function Brand({overlay = false}) {
    const {titleBefore, titleAccent, titleAfter, tagline} = LANDING.brand;
    return (
        <>
            <span className={`text-2xl font-bold ${overlay ? 'text-white' : 'text-brand-dark'}`}>
                {titleBefore}<span className={overlay ? 'text-secondary' : 'text-brand-red'}>{titleAccent}</span>{titleAfter}
            </span>
            <span className={`text-[16px] ${overlay ? 'text-white/70' : 'text-brand-dark/50'}`} style={{fontFamily: 'Poppins, sans-serif'}}>
                {tagline}
            </span>
        </>
    );
}
